import { useSelector } from "react-redux";

import GroupsIcon from "@mui/icons-material/Groups";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import DashboardLayout from "../components/common/DashboardLayout";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import GradeIcon from "@mui/icons-material/Grade";
import AddAlertIcon from "@mui/icons-material/AddAlert";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import CellTowerIcon from "@mui/icons-material/CellTower";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WidgetsIcon from "@mui/icons-material/Widgets";
import StyleIcon from "@mui/icons-material/Style";
import InsightsIcon from "@mui/icons-material/Insights";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CampaignIcon from "@mui/icons-material/Campaign";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PaidIcon from "@mui/icons-material/Paid";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RedeemIcon from "@mui/icons-material/Redeem";
import TimelineIcon from "@mui/icons-material/Timeline";
import CreateNewFolder from "@mui/icons-material/CreateNewFolder";
import AddToQueue from "@mui/icons-material/AddToQueue";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const mainListItemsArray = [
  {
    id: "0-1",
    label: "Customer Info",
    link: "/agent/customer-info",
    icon: <SupportAgentIcon />,
  },
  {
    id: "1-2",
    label: "Trading Activity",
    link: "/agent/trading-activity",
    icon: <InsightsIcon />,
  },
   {
    id: "0-3",
    label: "Conversion Analytics",
    link: "/agent/conversion-analytics",
    icon: <TrendingUpIcon />,
  },
    {
    id: 0-4,
    label: "Users",
    link: "/agent/users",
    icon: <GroupsIcon />,
  },
  {
    id: 0-5,
    label: "Customer Journey",
    link: "/agent/customer-journey",
    icon: <TimelineIcon />,
  },
  {
    id: 1,
    label: "Notifications & Engagement",
    icon: <NotificationsActiveIcon />,
    children: [
      {
        id: "1-1",
        label: "Push Notifications",
        link: "/agent/push-notifications",
        icon: <InsightsIcon />,
      },
      {
        id: "1-2",
        label: "One Signals",
        link: "/agent/one-signals",
        icon: <CellTowerIcon />,
      },
      // {
      //   id: "1-3",
      //   label: "User Rating",
      //   link: "/agent/user-rating",
      //   icon: <GradeIcon />,
      // },
      {
        id: "1-4",
        label: "User Support",
        link: "/agent/user-support",
        icon: <SupportAgentIcon />,
      },
      {
        id: "1-5",
        label: "Invoice",
        link: "/agent/invoice-dashboard",
        icon: <ReceiptLongIcon />,
      },

      // {
      //   id: "1-7",
      //   label: "Profit Cards",
      //   link: "/agent/profit-cards",
      //   icon: <StyleIcon />,
      // },
    ],
  },

  // {
  //   id: 5,
  //   label: "News",
  //   link: "/agent/news",
  //   icon: <NewspaperIcon />,
  // },

  {
    id: 6,
    label: "Marketing Spend Analysis",
    icon: <CampaignIcon />,
    children: [
      {
        id: "6-1",
        label: "Marketing Channel",
        link: "/agent/marketing-spend-analysis/marketing-channel",
        icon: <AccountTreeIcon />,
      },
      {
        id: "6-2",
        label: "Marketing Spend",
        link: "/agent/marketing-spend-analysis/marketing-spend",
        icon: <PaidIcon />,
      },
    ],
  },
  {
    id: 7,
    label: "Broker Connectivity",
    link: "/agent/broker-connectivity",
    icon: <AccountBalanceIcon />,
  },

  // {
  //   id: 2,
  //   label: "Stock-Alerts",
  //   link: "/agent/stock-alerts",
  //   icon: <AddAlertIcon />,
  // },

  {
    id: 4,
    label: "Misc",
    icon: <WidgetsIcon />,
    children: [
      {
        id: "4-1",
        label: "Subscription-Visit",
        link: "/agent/user-subscription-history",
        icon: <RecentActorsIcon />,
      },
      // {
      //   id: "4-10",
      //   label: "Performance Cards",
      //   link: "/agent/performance-cards",
      //   icon: <InsightsIcon />,
      // },
      {
        id: "4-2",
        label: "Intro Screens",
        link: "/agent/intro-screens",
        icon: <SmartphoneIcon />,
      },
    ],
  },
];

export default function AgentDashboardLayout() {
  const userState = useSelector((store) => store.auth);
  const isAdmin = userState?.user?.userDetails?.user_type?.toLowerCase() === "admin";

  const secondaryListItemsArray = [
    {
      id: 1,
      label: "Plans & Subscriptions",
      icon: <CreateNewFolder />,
      children: [
        {
          id: "1-1",
          label: "Coupons",
          link: "/agent/coupons",
          icon: <RedeemIcon />,
        },
        // Create Plan is admin-only — marketing role can view coupons/topups but not create plans
        ...(isAdmin
          ? [
            {
              id: "1-2",
              label: "Create Plan",
              link: "/agent/create-plan",
              icon: <CreateNewFolder />,
            },
          ]
          : []),
        {
          id: "1-3",
          label: "Create TopUp",
          link: "/agent/create-topup",
          icon: <AddToQueue />,
        },
        {
          id: "1-4",
          label: "Payment Link",
          link: "/agent/payment-link",
          icon: <PaidIcon />,
        },
        {
          id: "1-5",
          label: "Create QR",
          link: "/agent/create-qr",
          icon: <QrCode2Icon />,
        },
        {
          id: "1-6",
          label: "Payment Gateway Configuration",
          link: "/agent/payment-gateway-configuration",
          icon: <SettingsSuggestIcon />,
        },
      ],
    },
    {
      id: 2,
      label: "Payments & Refunds",
      icon: <ReceiptIcon />,
      children: [
        {
          id: "2-1",
          label: "Payments",
          link: "/agent/payments-dashboard",
          icon: <ReceiptIcon />,
        },
        {
          id: "2-2",
          label: "Refund Dashboard",
          link: "/agent/user-refunds",
          icon: <CurrencyExchangeIcon />,
        },
        {
          id: "2-3",
          label: "Failed Payments",
          link: "/agent/failed-payments",
          icon: <CurrencyExchangeIcon />,
        },
        {
          id: "2-4",
          label: "Refund Module Access",
          link: "/agent/refund-module-access",
          icon: <AdminPanelSettingsIcon />,
        },
        {
          id: "2-5",
          label: "Autopay Records",
          link: "/agent/autopay-records",
          icon: <AutorenewIcon />,
        },
      ],
    },
  ];

  return (
    <DashboardLayout
      mainListItems={mainListItemsArray}
      secondListItems={secondaryListItemsArray}
    />
  );
}
